<template>
  <!-- 详情弹框开始 -->
  <el-dialog title="详情" :visible.sync="DataDetails" width="40%" @close="cancel">
    <el-form :model="applyWxTbs">
      <div style="width:100%;
          height:500px;overflow-y: scroll;">
        <div class="detail_01">
          <div>联系信息</div>
          <div>
            <el-form-item label="超管姓名" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.contactName" auto-complete="off" style="width:70%"></el-input>
              <div
                v-popover:popover5
                style="margin-left:20px;color:#E04B4D;font-size:10px"
              >{{applyDescData.w1.length>7?applyDescData.w1.slice(0,7)+'···':applyDescData.w1}}</div>
              <el-popover
                ref="popover5"
                placement="top"
                width="270"
                v-model="visible2"
                trigger="hover"
              >
                <p>{{applyDescData.w1}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="超管手机号" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.contactPhone" auto-complete="off" style="width:70%"></el-input>
              <div
                v-popover:popover4
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w2.length>7?applyDescData.w2.slice(0,7)+'···':applyDescData.w2}}</div>
              <el-popover
                ref="popover4"
                placement="top"
                width="270"
                v-model="visible3"
                trigger="hover"
              >
                <p>{{applyDescData.w2}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible3 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="超管电子邮箱" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.contactEmail" auto-complete="off" style="width:70%"></el-input>
              <div
                v-popover:popover3
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w3.length>7?applyDescData.w3.slice(0,7)+'···':applyDescData.w3}}</div>
              <el-popover
                ref="popover3"
                placement="top"
                width="270"
                v-model="visible4"
                trigger="hover"
              >
                <p>{{applyDescData.w3}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible4 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
          </div>
        </div>
        <div class="detail_02">
          <div>经营信息</div>
          <div>
            <el-form-item label="简称" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.shopShortName" auto-complete="off" style="width:70%"></el-input>
                <div
                v-popover:popover2
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w4.length>7?applyDescData.w4.slice(0,7)+'···':applyDescData.w4}}</div>
              <el-popover
                ref="popover2"
                placement="top"
                width="270"
                v-model="visible5"
                trigger="hover"
              >
                <p>{{applyDescData.w4}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible5 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="开户类型" :label-width="LabelWidth">
              <el-radio-group v-model="checked2" style="margin-top:12px" @change="checkChangeValue">
                <el-radio :label="1">企业</el-radio>
                <el-radio :label="2">个体工商</el-radio>
                <el-radio :label="3">政府及事业单位</el-radio>
                <el-radio :label="4">其他组织</el-radio>
              </el-radio-group>
                <div
                v-popover:popover6
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w6.length>5?applyDescData.w6.slice(0,7)+'···':applyDescData.w6}}</div>
              <el-popover
                ref="popover6"
                placement="top"
                width="100"
                v-model="visible6"
                trigger="hover"
              >
                <p>{{applyDescData.w6}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible6 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="经营类目" :label-width="LabelWidth">
              <el-select
                v-model="value"
                filterable
                placeholder="请选择"
                size="mini"
                style="width:24%"
                disabled
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="value2"
                @change="remoteMethod"
                filterable
                placeholder="请选择"
                size="mini"
                style="width:24%"
              >
                <el-option
                  v-for="item in secondary"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="value3"
                filterable
                placeholder="请选择"
                size="mini"
                style="width:24%"
              >
                <el-option
                  v-for="item in  minimum"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
                <div
                v-popover:popover7
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w5.length>5?applyDescData.w5.slice(0,7)+'···':applyDescData.w5}}</div>
              <el-popover
                ref="popover7"
                placement="top"
                width="100"
                v-model="visible7"
                trigger="hover"
              >
                <p>{{applyDescData.w5}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible7 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>

            <el-form-item label="售卖场景" :label-width="LabelWidth">
              <el-checkbox v-model="checked">线下场所</el-checkbox>
              <el-checkbox disabled>公众号/小程序</el-checkbox>
              <el-checkbox disabled>网站</el-checkbox>
              <el-checkbox disabled>APP</el-checkbox>
               <div
                v-popover:popover8
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w7.length>2?applyDescData.w7.slice(0,2)+'···':applyDescData.w7}}</div>
              <el-popover
                ref="popover8"
                placement="top"
                width="270"
                v-model="visible8"
                trigger="hover"
              >
                <p>{{applyDescData.w7}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible8 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="门店地址" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.shopAddress" auto-complete="off" style="width:70%"></el-input>
               <div
                v-popover:popover9
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w8.length>7?applyDescData.w8.slice(0,7)+'···':applyDescData.w8}}</div>
              <el-popover
                ref="popover9"
                placement="top"
                width="270"
                v-model="visible9"
                trigger="hover"
              >
                <p>{{applyDescData.w8}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible9 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="特殊资质图片" :label-width="LabelWidth">
              <el-upload
                action="/api/shop/imageUpload"
                name="image"
                list-type="picture-card"
                :on-success="successData"
                :data="uploadData"
                :headers="headers"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="img" v-if="businessQualificationImg">
                <img :src="businessQualificationImg" alt="暂无图片" />
              </div>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
                 <div
                v-popover:popover10
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w9.length>7?applyDescData.w9.slice(0,7)+'···':applyDescData.w9}}</div>
              <el-popover
                ref="popover10"
                placement="top"
                width="270"
                v-model="visible10"
                trigger="hover"
              >
                <p v-html="applyDescData.w9"></p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible10 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="补充材料1" :label-width="LabelWidth">
              <el-upload
                action="/api/shop/imageUpload"
                name="image"
                list-type="picture-card"
                :on-success="successData2"
                :data="uploadData"
                :headers="headers"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <div class="img" v-if="supplementaryMaterialsImgUrl1">
                <img :src="supplementaryMaterialsImgUrl1" alt="暂无图片" />
              </div>
              <div
                v-popover:popover11
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w10.length>2?applyDescData.w10.slice(0,2)+'···':applyDescData.w10}}</div>
              <el-popover
                ref="popover11"
                placement="top"
                width="270"
                v-model="visible11"
                trigger="hover"
              >
                <p v-html="applyDescData.w10"></p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible11 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="补充材料2" :label-width="LabelWidth">
              <el-upload
                action="/api/shop/imageUpload"
                name="image"
                list-type="picture-card"
                :on-success="successData7"
                :data="uploadData"
                :headers="headers"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <div class="img" v-if="supplementaryMaterialsImgUrl2">
                <img :src="supplementaryMaterialsImgUrl2" alt="暂无图片" />
              </div>
            </el-form-item>
            <el-form-item label="补充材料3" :label-width="LabelWidth">
              <el-upload
                action="/api/shop/imageUpload"
                name="image"
                list-type="picture-card"
                :on-success="successData8"
                :data="uploadData"
                :headers="headers"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <div class="img" v-if="supplementaryMaterialsImgUrl3">
                <img :src="supplementaryMaterialsImgUrl3" alt="暂无图片" />
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="detail_02">
          <div>商户信息</div>
          <div>
            <el-form-item label="营业执照照片" :label-width="LabelWidth">
              <el-upload
                action="/api/shop/imageUpload"
                name="image"
                list-type="picture-card"
                :on-success="successData3"
                :data="uploadData"
                :headers="headers"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="img" v-if="shopImg">
                <img :src="shopImg" alt="暂无图片" />
              </div>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrls" alt />
              </el-dialog>
              <div
                v-popover:popover12
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w11.length>7?applyDescData.w11.slice(0,7)+'···':applyDescData.w11}}</div>
              <el-popover
                ref="popover12"
                placement="top"
                width="270"
                v-model="visible12"
                trigger="hover"
              >
                <p>{{applyDescData.w11}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible12 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="营业执照注册号" :label-width="LabelWidth">
              <el-input
                v-model="applyWxTbs.businessLicenseRegisterId"
                auto-complete="off"
                style="width:70%"
              ></el-input>
             <div
                v-popover:popover13
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w12.length>7?applyDescData.w12.slice(0,7)+'···':applyDescData.w12}}</div>
              <el-popover
                ref="popover13"
                placement="top"
                width="270"
                v-model="visible13"
                trigger="hover"
              >
                <p>{{applyDescData.w12}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible13 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="营业期限" :label-width="LabelWidth">
              <el-input
                v-model="applyWxTbs.businessTimeValidity"
                auto-complete="off"
                style="width:70%"
              ></el-input>
               <div
                v-popover:popover14
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w13.length>7?applyDescData.w13.slice(0,7)+'···':applyDescData.w13}}</div>
              <el-popover
                ref="popover14"
                placement="top"
                width="270"
                v-model="visible14"
                trigger="hover"
              >
                <p>{{applyDescData.w13}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible14 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="经营范围" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.businessScope" auto-complete="off" style="width:70%"></el-input>
              <div
                v-popover:popover15
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w14.length>7?applyDescData.w14.slice(0,7)+'···':applyDescData.w14}}</div>
              <el-popover
                ref="popover15"
                placement="top"
                width="270"
                v-model="visible15"
                trigger="hover"
              >
                <p>{{applyDescData.w14}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible15 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="商户全称" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.shopName" auto-complete="off" style="width:70%"></el-input>
               <div
                v-popover:popover16
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w15.length>7?applyDescData.w15.slice(0,7)+'···':applyDescData.w15}}</div>
              <el-popover
                ref="popover16"
                placement="top"
                width="270"
                v-model="visible16"
                trigger="hover"
              >
                <p>{{applyDescData.w15}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible16 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="商户注册地址" :label-width="LabelWidth">
              <el-input
                v-model="applyWxTbs.shopRegisterAddress"
                auto-complete="off"
                style="width:70%"
              ></el-input>
               <div
                v-popover:popover17
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w16.length>7?applyDescData.w16.slice(0,7)+'···':applyDescData.w16}}</div>
              <el-popover
                ref="popover17"
                placement="top"
                width="270"
                v-model="visible17"
                trigger="hover"
              >
                <p>{{applyDescData.w16}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible17 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
          </div>
        </div>
        <div class="detail_02">
          <div>企业法人/经办人</div>
          <div style="margin:15px 0;">
            <el-switch v-model="switchValue" active-text="身份证上传" inactive-text="护照上传"></el-switch>
          </div>
          <div>
            <div v-if="switchValue===true">
              <el-form-item label="法人证件（身份证正面）" :label-width="LabelWidth">
                <el-upload
                  action="/api/shop/imageUpload"
                  name="image"
                  list-type="picture-card"
                  :on-success="successData4"
                  :data="uploadData"
                  :headers="headers"
                  :before-upload="beforeUpload"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <div class="img" v-if="legalPersonCertificatesImgUrl1">
                  <img :src="legalPersonCertificatesImgUrl1" alt="暂无图片" />
                </div>
              <div
                v-popover:popover18
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w17.length>7?applyDescData.w17.slice(0,7)+'···':applyDescData.w17}}</div>
              <el-popover
                ref="popover18"
                placement="top"
                width="270"
                v-model="visible18"
                trigger="hover"
              >
                <p>{{applyDescData.w17}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible18 = false">取消</el-button>
                </div>
              </el-popover>
              </el-form-item>
              <el-form-item label="法人证件（身份证反面）" :label-width="LabelWidth">
                <el-upload
                  action="/api/shop/imageUpload"
                  name="image"
                  list-type="picture-card"
                  :on-success="successData5"
                  :data="uploadData"
                  :headers="headers"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <div class="img" v-if="legalPersonCertificatesImgUrl2">
                  <img :src="legalPersonCertificatesImgUrl2" alt="暂无图片" />
                </div>
               <div
                v-popover:popover19
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w18.length>7?applyDescData.w18.slice(0,7)+'···':applyDescData.w18}}</div>
              <el-popover
                ref="popover19"
                placement="top"
                width="270"
                v-model="visible19"
                trigger="hover"
              >
                <p>{{applyDescData.w18}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible19 = false">取消</el-button>
                </div>
              </el-popover>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="法人证件（护照影印件）" :label-width="LabelWidth">
                <el-upload
                  action="/api/shop/imageUpload"
                  name="image"
                  list-type="picture-card"
                  :on-success="successData6"
                  :data="uploadData"
                  :headers="headers"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" size="tiny">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <div class="img" v-if="legalPersonCertificatesImgUrl3">
                  <img :src="legalPersonCertificatesImgUrl3" alt="暂无图片" />
                </div>
                <div
                v-popover:popover20
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w19.length>8?applyDescData.w19.slice(0,8)+'···':applyDescData.w19}}</div>
              <el-popover
                ref="popover20"
                placement="top"
                width="270"
                v-model="visible20"
                trigger="hover"
              >
                <p>{{applyDescData.w19}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible20 = false">取消</el-button>
                </div>
              </el-popover>
              </el-form-item>
            </div>
            <el-form-item label="法人证件号码" :label-width="LabelWidth">
              <el-input
                v-model="applyWxTbs.legalPersonCertificatesId"
                auto-complete="off"
                style="width:70%"
              ></el-input>
              <div
                v-popover:popover21
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w20.length>7?applyDescData.w20.slice(0,7)+'···':applyDescData.w20}}</div>
              <el-popover
                ref="popover21"
                placement="top"
                width="270"
                v-model="visible21"
                trigger="hover"
              >
                <p>{{applyDescData.w20}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible21 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="法人证件持有人姓名" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.legalPersonName" auto-complete="off" style="width:70%"></el-input>
              <div
                v-popover:popover22
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w21.length>7?applyDescData.w21.slice(0,7)+'···':applyDescData.w21}}</div>
              <el-popover
                ref="popover22"
                placement="top"
                width="270"
                v-model="visible22"
                trigger="hover"
              >
                <p>{{applyDescData.w21}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible22 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="证件有效期" :label-width="LabelWidth">
              <el-input
                v-model="applyWxTbs.legalPersonTimeValidity"
                auto-complete="off"
                style="width:70%"
              ></el-input>
             <div
                v-popover:popover23
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w22.length>7?applyDescData.w22.slice(0,7)+'···':applyDescData.w22}}</div>
              <el-popover
                ref="popover23"
                placement="top"
                width="270"
                v-model="visible23"
                trigger="hover"
              >
                <p>{{applyDescData.w22}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible23 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
          </div>
        </div>
        <div class="detail_01">
          <div>结算信息</div>
          <div>
            <el-form-item label="账户类型" :label-width="LabelWidth">
              <el-radio-group v-model="checked3" style="margin-top:12px">
                <el-radio :label="1">对公账户</el-radio>
                <el-radio :label="2">法人账户</el-radio>
              </el-radio-group>
             <div
                v-popover:popover24
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w23.length>7?applyDescData.w23.slice(0,7)+'···':applyDescData.w23}}</div>
              <el-popover
                ref="popover24"
                placement="top"
                width="100"
                v-model="visible24"
                trigger="hover"
              >
                <p>{{applyDescData.w23}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible24 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="开户名称" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.accountName" auto-complete="off" style="width:70%"></el-input>
            <div
                v-popover:popover25
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w24.length>7?applyDescData.w24.slice(0,7)+'···':applyDescData.w24}}</div>
              <el-popover
                ref="popover25"
                placement="top"
                width="100"
                v-model="visible25"
                trigger="hover"
              >
                <p>{{applyDescData.w24}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible25 = false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="基本户开户银行" :label-width="LabelWidth">
              <el-select v-model="bankValue" placeholder="请选择" style="width:75%">
                <el-option
                  v-for="item in bankData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
             <div
                v-popover:popover26
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w25.length>7?applyDescData.w25.slice(0,7)+'···':applyDescData.w25}}</div>
              <el-popover
                ref="popover26"
                placement="top"
                width="270"
                v-model="visible26"
                trigger="hover"
              >
                <p>{{applyDescData.w25}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible26= false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="开户银行城市" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.accountBankCity" auto-complete="off" style="width:70%"></el-input>
             <div
                v-popover:popover27
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w26.length>7?applyDescData.w26.slice(0,7)+'···':applyDescData.w26}}</div>
              <el-popover
                ref="popover27"
                placement="top"
                width="270"
                v-model="visible27"
                trigger="hover"
              >
                <p>{{applyDescData.w26}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible27= false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="基本户开户银行支行" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.accountBankSub" auto-complete="off" style="width:70%"></el-input>
             <div
                v-popover:popover28
                style="margin-left:20px;color:#E04B4D;font-size:10px;"
              >{{applyDescData.w27.length>7?applyDescData.w27.slice(0,7)+'···':applyDescData.w27}}</div>
              <el-popover
                ref="popover28"
                placement="top"
                width="270"
                v-model="visible28"
                trigger="hover"
              >
                <p>{{applyDescData.w27}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible28= false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="基本户银行账号" :label-width="LabelWidth">
              <el-input v-model="applyWxTbs.accountBankNum" auto-complete="off" style="width:70%"></el-input>
             <div
                v-popover:popover29
                style="margin-left:20px;color:#E04B4D;font-size:8px;"
              >{{applyDescData.w28.length>2?applyDescData.w28.slice(0,2)+'···':applyDescData.w28}}</div>
              <el-popover
                ref="popover29"
                placement="top"
                width="270"
                v-model="visible2"
                trigger="hover"
              >
                <p v-html="applyDescData.w28 +'(点击查看)'"></p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible29= false">取消</el-button>
                </div>
              </el-popover>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cencelChr">取 消</el-button>
      <el-button type="primary" @click="sureEdit">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 详情弹框结束 -->
</template>

<script>
import Vue from "vue";
import { getToken } from "../../../utils/auth.js";
export default {
  props: [
    "DataDetail",
    "cencel",
    "applyWxTbData",
    "weChatData",
    "applyDescs",
    "getBankData"
  ],
  data() {
    return {
      // 详情图片上传
      dialogImageUrl: "",
      dialogImageUrls: "",
      dialogVisible: false,
      LabelWidth: "180px", //详情输入框宽度
      DataDetails: false, //弹框的显示控制
      applyWxTbs: {}, //进件数据
      checked: true, //售卖场景
      switchValue: true, //证件上传选择
      // 开户类型单选框
      checked2: 0,
      checked3: 0,
      options: [
        {
          //经营类目第一选择框
          value: "企业",
          label: "企业"
        },
        {
          value: "个体工商户",
          label: "个体工商户"
        },
        {
          value: "政府及事业单位",
          label: "政府及事业单位"
        },
        {
          value: "其他组织",
          label: "其他组织"
        }
      ],
      bankData: [], //所有开户银行
      bankValue: "", //选中的银行值
      secondary: [
        {
          //经营类目第一选择框
          value: "线下零售",
          label: "线下零售"
        },
        {
          value: "网上购物",
          label: "网上购物"
        },
        {
          value: "居民生活/商业服务",
          label: "居民生活/商业服务"
        },
        {
          value: "休闲娱乐",
          label: "休闲娱乐"
        },
        {
          value: "交通出行/票务旅游",
          label: "交通出行/票务旅游"
        },
        {
          value: "网络媒体/计算机服务/游戏",
          label: "网络媒体/计算机服务/游戏"
        },
        {
          value: "金融",
          label: "金融"
        },
        {
          value: "网络服务平台",
          label: "网络服务平台"
        },
        {
          value: "教育/医疗",
          label: "教育/医疗"
        },
        {
          value: "生活缴费",
          label: "生活缴费"
        },
        {
          value: "收藏拍卖",
          label: "收藏拍卖"
        },
        {
          value: "餐饮",
          label: "餐饮"
        },
        {
          value: "其他",
          label: "其他"
        }
      ], //经营类目第二选择框

      value: "", //经营类目选择框一
      value2: "", //经营类目选择框二
      value3: "", //经营类目选择框三
      fileLists: [], //图片上传
      headers: {
        token: getToken().Token
      },
      shopImg: "", //营业执照
      businessQualificationImg: "", //特殊资质图片
      legalPersonCertificatesImgUrl1: "", //法人证件照片
      legalPersonCertificatesImgUrl2: "",
      legalPersonCertificatesImgUrl3: "",
      supplementaryMaterialsImgUrl1: "", //补充材料
      supplementaryMaterialsImgUrl2: "",
      supplementaryMaterialsImgUrl3: "",

      // 图片上传成功的ID
      businessQualificationImgId: "", //特殊资质id
      supplementaryMaterialsImgUrl1Id: "", //补充材料1 id
      supplementaryMaterialsImgUrl2Id: "", //补充材料2 id
      supplementaryMaterialsImgUrl3Id: "", //补充材料3 id
      shopImgId: "", //营业执照id
      legalPersonCertificatesImgUrl1Id: "", //法人证件正面id
      legalPersonCertificatesImgUrl2Id: "", //法人证件反面Id
      legalPersonCertificatesImgUrl3Id: "", //法人证件护照ID

      applyDescData: {
        w1: "",
        w2: "",
        w3: "",
        w4: "",
        w5: "",
        w6: "",
        w7: "",
        w8: "",
        w9: "",
        w10: "",
        w11: "",
        w12: "",
        w13: "",
        w14: "",
        w15: "",
        w16: "",
        w17: "",
        w18: "",
        w19: "",
        w20: "",
        w21: "",
        w22: "",
        w23: "",
        w24: "",
        w25: "",
        w26: "",
        w27: "",
        w28: "",
      }, //传递过来的字段
      visible2: false, //消息提示
      visible3: false, //消息提示
      visible4: false, //消息提示
      visible5: false, //消息提示
      visible6: false, //消息提示
      visible7: false, //消息提示
      visible8: false, //消息提示
      visible9: false, //消息提示
      visible10: false, //消息提示
      visible11: false, //消息提示
      visible12: false, //消息提示
      visible13: false, //消息提示
      visible14: false, //消息提示
      visible15: false, //消息提示
      visible16: false, //消息提示
      visible17: false, //消息提示
      visible18: false, //消息提示
      visible19: false, //消息提示
      visible20: false, //消息提示
      visible21: false, //消息提示
      visible22: false, //消息提示
      visible23: false, //消息提示
      visible24: false, //消息提示
      visible: false, //消息提示
      visible25: false, //消息提示
      visible26: false, //消息提示
      visible27: false, //消息提示
      visible28: false, //消息提示
      visible29:false,
    };
  },
  computed: {
    minimum() {
      //根据第二个选择框的值渲染第三个选择框的内容
      let minimums = [];
      if (this.value2 === "线下零售") {
        minimums = [
          {
            //经营类目第一选择框
            value: "超市",
            label: "超市"
          },
          {
            value: "便利店",
            label: "便利店"
          },
          {
            value: "自动贩卖机",
            label: "自动贩卖机"
          },
          {
            value: "百货",
            label: "百货"
          },
          {
            value: "数码电器/电脑办公",
            label: "数码电器/电脑办公"
          },
          {
            value: "家具建材/家具厨具",
            label: "家具建材/家具厨具"
          },
          {
            value: "食品生鲜",
            label: "食品生鲜"
          },
          {
            value: "服饰箱包",
            label: "服饰箱包"
          },
          {
            value: "运动户外",
            label: "运动户外"
          },
          {
            value: "美妆个肤",
            label: "美妆个肤"
          },
          {
            value: "母婴用品/儿童玩具",
            label: "母婴用品/儿童玩具"
          },
          {
            value: "计生用品",
            label: "计生用品"
          },
          {
            value: "图书音像/文具乐器",
            label: "图书音像/文具乐器"
          },
          {
            value: "黄金珠宝",
            label: "黄金珠宝"
          },
          {
            value: "钟表眼镜",
            label: "钟表眼镜"
          },
          {
            value: "宠物/宠物用品",
            label: "宠物/宠物用品"
          },
          {
            value: "礼品鲜花/农资绿植",
            label: "礼品鲜花/农资绿植"
          },
          {
            value: "批发业",
            label: "批发业"
          }
        ];
      }
      if (this.value2 === "网上购物") {
        minimums = [
          {
            //经营类目第一选择框
            value: "线上商超",
            label: "线上商超"
          }
        ];
      }
      if (this.value2 === "餐饮") {
        minimums = [
          {
            //经营类目第一选择框
            value: "快餐",
            label: "快餐"
          },
          {
            value: "火锅",
            label: "火锅"
          },
          {
            value: "烧烤",
            label: "烧烤"
          },
          {
            value: "小吃/熟食",
            label: "小吃/熟食"
          },
          {
            value: "其他中餐",
            label: "其他中餐"
          },
          {
            value: "日韩/东南亚菜",
            label: "日韩/东南亚菜"
          },
          {
            value: "西餐",
            label: "西餐"
          },
          {
            value: "咖啡厅",
            label: "咖啡厅"
          },
          {
            value: "甜品饮品",
            label: "甜品饮品"
          },
          {
            value: "烘焙糕点",
            label: "烘焙糕点"
          }
        ];
      }
      if (this.value2 === "居民生活/商业服务") {
        minimums = [
          {
            //经营类目第一选择框
            value: "物流/快递",
            label: "物流/快递"
          },
          {
            value: "咨询/法律咨询/金融咨询等",
            label: "咨询/法律咨询/金融咨询等"
          },
          {
            value: "婚庆/摄影",
            label: "婚庆/摄影"
          },
          {
            value: "装饰/设计",
            label: "装饰/设计"
          },
          {
            value: "家政/维修服务",
            label: "家政/维修服务"
          },
          {
            value: "广告/会展/活动策划",
            label: "广告/会展/活动策划"
          },
          {
            value: "人才中介机构/招聘/猎头",
            label: "人才中介机构/招聘/猎头"
          },
          {
            value: "职业社交/婚介/交友",
            label: "职业社交/婚介/交友"
          },
          {
            value: "房地产",
            label: "房地产"
          },
          {
            value: "烘苗木种植/园林绿化焙糕点",
            label: "苗木种植/园林绿化"
          },
          {
            value: "搬家/回收",
            label: "搬家/回收"
          },
          {
            value: "宠物医院",
            label: "宠物医院"
          },
          {
            value: "共享服务",
            label: "共享服务"
          }
        ];
      }
      if (this.value2 === "休闲娱乐") {
        minimums = [
          {
            //经营类目第一选择框
            value: "物流/快递",
            label: "娱乐票务"
          },
          {
            value: "咨询/法律咨询/金融咨询等",
            label: "运动健身会所"
          },
          {
            value: "婚庆/摄影",
            label: "俱乐部/休闲会所"
          },
          {
            value: "装饰/设计",
            label: "游艺厅/KTV/网吧"
          },
          {
            value: "家政/维修服务",
            label: "院线影城"
          },
          {
            value: "广告/会展/活动策划",
            label: "演出赛事"
          },
          {
            value: "人才中介机构/招聘/猎头",
            label: "美发/美容/美甲店"
          },
          {
            value: "职业社交/婚介/交友",
            label: "酒吧"
          }
        ];
      }
      if (this.value2 === "交通出行/票务旅游") {
        minimums = [
          {
            //经营类目第一选择框
            value: "租车",
            label: "租车"
          },
          {
            value: "加油",
            label: "加油"
          },
          {
            value: "铁路客运",
            label: "铁路客运"
          },
          {
            value: "高速收费",
            label: "高速收费"
          },
          {
            value: "城市公共交通",
            label: "城市公共交通"
          },
          {
            value: "船舶/海运服务",
            label: "船舶/海运服务"
          },
          {
            value: "旅行社",
            label: "旅行社"
          },
          {
            value: "机票/机票代理",
            label: "机票/机票代理"
          },
          {
            value: "汽车用品",
            label: "汽车用品"
          },
          {
            value: "汽车美容/维修保养",
            label: "汽车美容/维修保养"
          },
          {
            value: "停车缴费",
            label: "停车缴费"
          },
          {
            value: "旅馆/酒店/度假区",
            label: "旅馆/酒店/度假区"
          },
          {
            value: "景区",
            label: "景区"
          }
        ];
      }
      if (this.value2 === "网络媒体/计算机服务/游戏") {
        minimums = [
          {
            //经营类目第一选择框
            value: "在线图书/视频/音乐",
            label: "在线图书/视频/音乐"
          },
          {
            value: "门户/资讯/论坛",
            label: "门户/资讯/论坛"
          },
          {
            value: "游戏",
            label: "游戏"
          },
          {
            value: "网络直播",
            label: "网络直播"
          },
          {
            value: "软件/建站/技术开发",
            label: "软件/建站/技术开发"
          },
          {
            value: "网络推广/网络广告",
            label: "网络推广/网络广告"
          }
        ];
      }
      if (this.value2 === "网络服务平台") {
        minimums = [
          {
            //经营类目第一选择框
            value: "团购服务平台",
            label: "团购服务平台"
          },
          {
            value: "综合生活服务平台",
            label: "综合生活服务平台"
          },
          {
            value: "旅游服务平台",
            label: "旅游服务平台"
          },
          {
            value: "订餐服务平台",
            label: "订餐服务平台"
          }
        ];
      }
      if (this.value2 === "教育/医疗") {
        minimums = [
          {
            //经营类目第一选择框
            value: "教育/培训/考试缴费/学费",
            label: "教育/培训/考试缴费/学费"
          },
          {
            value: "民办大学及学院",
            label: "民办大学及学院"
          },
          {
            value: "民办中小幼",
            label: "民办中小幼"
          },
          {
            value: "保健器械/医疗器械/非处方药品",
            label: "保健器械/医疗器械/非处方药品"
          },
          {
            value: "保健信息咨询平台",
            label: "保健信息咨询平台"
          },
          {
            value: "私立/民营医院/诊所",
            label: "私立/民营医院/诊所"
          },
          {
            value: "挂号平台",
            label: "挂号平台"
          }
        ];
      }
      if (this.value2 === "生活缴费") {
        minimums = [
          {
            //经营类目第一选择框
            value: "电信运营商",
            label: "电信运营商"
          },
          {
            value: "宽带收费",
            label: "宽带收费"
          },
          {
            value: "话费通讯",
            label: "话费通讯"
          },
          {
            value: "有线电视缴费",
            label: "有线电视缴费"
          },
          {
            value: "物业管理费",
            label: "物业管理费"
          },
          {
            value: "其他生活缴费",
            label: "其他生活缴费"
          },
          {
            value: "公共事业（水电煤气）",
            label: "公共事业（水电煤气）"
          },
          {
            value: "交通罚款",
            label: "交通罚款"
          }
        ];
      }
      if (this.value2 === "金融") {
        minimums = [
          {
            //经营类目第一选择框
            value: "财经资讯",
            label: "财经资讯"
          },
          {
            value: "股票软件类",
            label: "股票软件类"
          },
          {
            value: "保险业务",
            label: "保险业务"
          },
          {
            value: "众筹",
            label: "众筹"
          },
          {
            value: "信用还款",
            label: "信用还款"
          }
        ];
      }
      if (this.value2 === "收藏拍卖") {
        minimums = [
          {
            //经营类目第一选择框
            value: "非文物类收藏品",
            label: "非文物类收藏品"
          },
          {
            value: "文物经营/文物复制品销售",
            label: "文物经营/文物复制品销售"
          },
          {
            value: "拍卖/典当",
            label: "拍卖/典当"
          }
        ];
      }
      if (this.value2 === "其他") {
        minimums = [
          {
            //经营类目第一选择框
            value: "其他行业",
            label: "其他行业"
          }
        ];
      }
      return minimums;
    },
    // 照片上传data
    uploadData() {
      //文件上传数据
      const { shopId, projectContractorId } = this.weChatData;
      return { projectId: projectContractorId, shopId };
    }
  },
  watch: {
    getBankData() {
      //开户城市
      this.bankData = [];
      for (let i in this.getBankData) {
        this.bankData.push({
          value: this.getBankData[i],
          label: this.getBankData[i]
        });
      }
    },
    applyDescs() {
      this.applyDescData = { ...this.applyDescs };
    },
    DataDetail() {
      //监听父级传过来的value
      this.DataDetails = this.DataDetail;
    },
    applyWxTbData() {
      //单选框的value
      this.checked2 = this.applyWxTbData.applyType;
      this.checked3 = this.applyWxTbData.accountType;
      this.applyWxTbs = { ...this.applyWxTbData };
      // 营业执照图片
      if (
        this.DataDetails == true &&
        // 获取对象的长度
        Object.getOwnPropertyNames(this.applyWxTbs).length !== 1
      ) {
        const {
          businessLicenseImgUrl, //营业执照照片
          businessQualificationImgUrl, //特殊资质照片
          legalPersonCertificatesImgUrl1, //法人证件照片
          legalPersonCertificatesImgUrl2,
          legalPersonCertificatesImgUrl3,
          supplementaryMaterialsImgUrl1, //补充材料照片
          supplementaryMaterialsImgUrl2,
          supplementaryMaterialsImgUrl3
        } = this.applyWxTbs;
        // 图片下载
        if (businessLicenseImgUrl !== "---") {
          //营业执照照片。封装的promise方法
          this.getPic(businessLicenseImgUrl).then(res => {
            this.shopImg = res;
          });
        }
        if (businessQualificationImgUrl !== "---") {
          //特殊资质照片
          this.getPic(businessQualificationImgUrl).then(res => {
            this.businessQualificationImg = res;
          });
        }
        if (legalPersonCertificatesImgUrl1 !== "---") {
          //法人证件照片
          this.getPic(legalPersonCertificatesImgUrl1).then(res => {
            this.legalPersonCertificatesImgUrl1 = res;
          });
        }
        if (legalPersonCertificatesImgUrl2 !== "---") {
          //法人证件照片
          this.getPic(legalPersonCertificatesImgUrl2).then(res => {
            this.legalPersonCertificatesImgUrl2 = res;
          });
        }
        if (legalPersonCertificatesImgUrl3 !== "---") {
          //法人证件照片
          this.getPic(legalPersonCertificatesImgUrl3).then(res => {
            this.legalPersonCertificatesImgUrl3 = res;
          });
        }
        if (supplementaryMaterialsImgUrl1 !== "---") {
          //补充材料照片
          this.getPic(supplementaryMaterialsImgUrl1).then(res => {
            this.supplementaryMaterialsImgUrl1 = res;
          });
        }
        if (supplementaryMaterialsImgUrl2 !== "---") {
          //补充材料照片
          this.getPic(supplementaryMaterialsImgUrl2).then(res => {
            this.supplementaryMaterialsImgUrl2 = res;
          });
        }
        if (supplementaryMaterialsImgUrl3 !== "---") {
          //补充材料照片
          this.getPic(supplementaryMaterialsImgUrl3).then(res => {
            this.supplementaryMaterialsImgUrl3 = res;
          });
        }
        // 经营类目value值分配到三个选择框中
        if (this.applyWxTbs.businessType !== undefined ) {
          this.value = this.applyWxTbs.businessType.split("-")[0];
          this.value2 = this.applyWxTbs.businessType.split("-")[1];
          this.value3 = this.applyWxTbs.businessType.split("-")[2];
        }
      }
    }
  },
  methods: {
    // 上传图片太大,压缩图片
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 4; // 判定图片大小是否小于4MB
        if (isLt2M) {
          resolve(file);
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then(res => {
          resolve(res);
        });
      });
    },
    // 当选择框二value发生变化时，清空选择框三
    remoteMethod() {
      this.value3 = "";
    },
    // 特殊资质上传成功时
    successData(res, fileList) {
      if (res.state === 1) {
        this.businessQualificationImgId = res.fileId;
        this.DeleteSuccess();
      } else {
        this.DeleteFailure();
      }
    },
    // 补充材料上传成功时
    successData2(res, fileList) {
      if (res.state === 1) {
        this.supplementaryMaterialsImgUrl1Id = res.fileId;
        this.DeleteSuccess();
      } else {
        this.DeleteFailure();
      }
    },
    // 营业执照上传成功时
    successData3(res, fileList) {
      if (res.state === 1) {
        this.shopImgId = res.fileId;
        this.DeleteSuccess();
        // 营业执照上传成功后调用识别名字，身份证号接口
        this.$axios
          .get("/shop/localImageReco", {
            params: { imageId: this.shopImgId, imageType: 3 }
          })
          .then(res => {
            if (res.data.state === 1) {
              const recoRes = res.data.recoRes;
              Vue.set(
                this.applyWxTbs,
                "businessLicenseRegisterId",
                recoRes.SocialCreditCode
              );
              Vue.set(
                this.applyWxTbs,
                "businessTimeValidity",
                recoRes.validStart + "-" + recoRes.validEnd + ""
              );
              Vue.set(this.applyWxTbs, "businessScope", recoRes.businessScope);
              Vue.set(this.applyWxTbs, "shopName", recoRes.institutionFullName);
              Vue.set(this.applyWxTbs, "shopRegisterAddress", recoRes.address);
            } else {
              this.open();
            }
          });
      } else {
        this.DeleteFailure();
      }
    },
    // 法人证件身份证正面上传成功时
    successData4(res, fileList) {
      if (res.state === 1) {
        this.legalPersonCertificatesImgUrl1Id = res.fileId;
        this.DeleteSuccess();
        // 身份证正面上传成功后调用识别名字，身份证号接口
        this.$axios
          .get("/shop/localImageReco", {
            params: {
              imageId: this.legalPersonCertificatesImgUrl1Id,
              imageType: 1
            }
          })
          .then(res => {
            if (res.data.state === 1) {
              const recoRes = res.data.recoRes;
              // 给this.applyWxTbs的K添加响应式操作，来触发视图更新
              Vue.set(
                this.applyWxTbs,
                "legalPersonCertificatesId",
                recoRes.card
              );
              Vue.set(this.applyWxTbs, "legalPersonName", recoRes.name);
            } else {
              this.open();
            }
          });
      } else {
        this.DeleteFailure();
      }
    },
    // 法人证件身份证反面上传成功时
    successData5(res, fileList) {
      if (res.state === 1) {
        this.legalPersonCertificatesImgUrl2Id = res.fileId;
        this.DeleteSuccess();
        // 身份证反面上传成功后调用识别名字，身份证号接口
        this.$axios
          .get("/shop/localImageReco", {
            params: {
              imageId: this.legalPersonCertificatesImgUrl2Id,
              imageType: 2
            }
          })
          .then(res => {
            if (res.data.state === 1) {
              const recoRes = res.data.recoRes;
              // 给this.applyWxTbs.legalPersonTimeValidity添加响应式操作，来触发视图更新
              Vue.set(
                this.applyWxTbs,
                "legalPersonTimeValidity",
                recoRes.validStart + "-" + recoRes.validEnd + ""
              );
            } else {
              this.open();
            }
          });
      } else {
        this.DeleteFailure();
      }
    },
    // 法人证件护照上传成功时
    successData6(res, fileList) {
      if (res.state === 1) {
        this.legalPersonCertificatesImgUrl3Id = res.fileId;
        this.DeleteSuccess();
      } else {
        this.DeleteFailure();
      }
    },
    // 补充材料2上传成功时
    successData7(res, fileList) {
      if (res.state === 1) {
        this.supplementaryMaterialsImgUrl2Id = res.fileId;
        this.DeleteSuccess();
      } else {
        this.DeleteFailure();
      }
    },
    // 补充材料3照上传成功时
    successData8(res, fileList) {
      if (res.state === 1) {
        this.supplementaryMaterialsImgUrl3Id = res.fileId;
        this.DeleteSuccess();
      } else {
        this.DeleteFailure();
      }
    },
    add(){
      console.log(1);
      
    },
    // 此方法为点击弹框右上角的 X 时，再次点击详情会出现不显示弹框的问题
    cancel(){
      this.cencel();
    },
    // 取消弹框
    cencelChr() {
      this.cencel(); //调用父级方法;
      this.applyWxTbs = {}; //清空
      this.value = "";
      this.value2 = "";
      this.value3 = "";
      this.shopImg = ""; //营业执照
      this.businessQualificationImg = ""; //特殊资质图片
      this.legalPersonCertificatesImgUrl1 = ""; //法人证件照片
      this.legalPersonCertificatesImgUrl2 = "";
      this.legalPersonCertificatesImgUrl3 = "";
      this.supplementaryMaterialsImgUrl1 = ""; //补充材料
      this.supplementaryMaterialsImgUrl2 = "";
      this.supplementaryMaterialsImgUrl3 = "";
    },
    // 点击确定，编辑进件
    sureEdit() {
      const {
        id,
        mchId,
        shopId,
        projectContractorId,
        contactName,
        contactPhone,
        contactEmail,
        shopShortName,
        businessType,
        businessScene,
        shopAddress,
        businessLicenseRegisterId,
        businessTimeValidity,
        businessScope,
        shopName,
        shopRegisterAddress,
        legalPersonCertificatesId,
        legalPersonName,
        legalPersonTimeValidity,
        accountType,
        accountName,
        accountBank,
        accountBankCity,
        accountBankSub,
        accountBankNum,
        applyType,
        certificatesType
      } = this.applyWxTbs;
      let accountTypes;
      if (accountType == "对公") {
        accountTypes = 1;
      } else if (accountType == "法人账户") {
        accountTypes = 2;
      }
      let certificatesTypes;
      if (this.switchValue === true) {
        certificatesTypes = 1;
      } else {
        certificatesTypes = 2;
      }
      this.$axios.get("/mchwx/applyEdit", {
          params: {
            applyId: id,
            mchId,
            shopId,
            projectId: projectContractorId,
            contactName,
            contactPhone,
            contactEmail,
            shopShortName,
            businessType: this.value + "-" + this.value2 + "-" + this.value3,
            businessScene,
            shopAddress,
            businessLicenseRegisterId,
            businessTimeValidity,
            businessScope,
            shopName,
            shopRegisterAddress,
            legalPersonCertificatesId,
            legalPersonName,
            legalPersonTimeValidity,
            accountType: this.checked3,
            accountName,
            accountBank,
            accountBankCity,
            accountBankSub,
            accountBankNum,
            applyType,
            certificatesType: certificatesTypes,
            businessQualificationImgUrl: this.businessQualificationImgId, //特殊资质图片
            supplementaryMaterialsImgUrl1: this.supplementaryMaterialsImgUrl1Id, //补充材料一
            supplementaryMaterialsImgUrl2: this.supplementaryMaterialsImgUrl2Id, //补充材料二
            supplementaryMaterialsImgUrl3: this.supplementaryMaterialsImgUrl3Id, //补充材料三
            businessLicenseImgUrl: this.shopImgId, //营业执照
            legalPersonCertificatesImgUrl1: this
              .legalPersonCertificatesImgUrl1Id, //法人证件(身份证正面)
            legalPersonCertificatesImgUrl2: this
              .legalPersonCertificatesImgUrl2Id, //法人证件(身份证反面)
            legalPersonCertificatesImgUrl3: this
              .legalPersonCertificatesImgUrl3Id //法人证件(护照影印件)
          }
        })
        .then(res => {
          if (res.data.state === 1) {
            this.DeleteSuccess();
          } else {
            this.DeleteFailure();
          }
        });
      this.cencel(); //调用父级方法取消弹框;
    },
    getPic(url) {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("/shop/imageDownload", {
            params: { imageId: url },
            responseType: "arraybuffer"
          })
          .then(res => {
            let value =
              "data:image/png;base64," +
              btoa(
                new Uint8Array(res.data).reduce(
                  (res, byte) => res + String.fromCharCode(byte),
                  ""
                )
              );
            resolve(value);
          });
      });
    },

    // 消息提示
    open() {
      this.$notify.error({
        title: "错误",
        message: "自动识别证照出错请手动输入！"
      });
    },
    //操作成功提示
    DeleteSuccess() {
      this.$message({
        message: "恭喜你，操作成功！",
        type: "success"
      });
    },
    //操作失败提示
    DeleteFailure() {
      this.$message.error("错了哦，操作失败！");
    },

    checkChangeValue() {
      if (this.checked2 === 1) {
        this.value = "企业";
      } else if (this.checked2 === 2) {
        this.value = "个体工商户";
      } else if (this.checked2 === 3) {
        this.value = "政府及事业单位";
      } else if (this.checked2 === 4) {
        this.value = "其他组织";
      }
    }
  }
};
</script>

<style>
.detail_01 {
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #edf1f3;
  margin-top: 20px;
}

.detail_02 {
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #edf1f3;
  margin-top: 20px;
}
.detail_01 > div {
  color: #606266;
  margin-left: 10px;
}
.detail_01 > div:first-child {
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 18px;
}
.detail_01 > div {
  color: #606266;
  margin-left: 10px;
}
.detail_02 > div:first-child {
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 18px;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #00c250;
  border-color: #00c250;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #00c250;
}
.img {
  width: 148px;
  height: 148px;
  border: 1px solid #ccc;
}
.img > img:first-child {
  width: 100%;
  height: 100%;
}
.el-form-item__content {
  display: flex;
}

/* 单选框 */

.el-radio__input.is-checked .el-radio__inner {
  background-color: #00c250;
  border-color: #00c250;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #00c250;
}
.el-switch.is-checked .el-switch__core {
  background-color: #00c250;
  border-color: #00c250;
}
.el-switch__label.is-active {
  color: #00c250;
}
</style>